import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default class AlertDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            origprops: props,
            open: props.open ? props.open : false,
            showopen: props.showopen ? props.showopen : false,
            showclose: props.showclose ? props.showclose : false,
            onClose: props.onClose
        }
    }   

    componentDidUpdate(prevProps) {
        if(this.state.open !== this.props.open)
            this.setState({open: this.props.open})
        if((this.state.onClose??'').toString() !== (this.props.onClose??'').toString())
            this.setState({onClose: this.props.onClose})
    }
  
    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState.origprops.open !== nextProps.open 
        || prevState.origprops.showopen !== nextProps.showopen 
        || prevState.origprops.showclose !== nextProps.showclose)
          return ({
            origprops: nextProps,
            open:  nextProps.open,
            showopen: nextProps.showopen ? nextProps.showopen : false,
            showclose: nextProps.showclose ? nextProps.showclose : false,
            onClose: nextProps.onClose
          });

        return false
    
      }
    onClose = this.props.onClose

    handleClick = (value) => {
        this.setState({open: false})
        if(this.state.onClose)
            this.state.onClose(value)
    }

    handleClose = (value) => {

        this.setState({open: false})
        if(this.state.onClose)
            this.state.onClose(value) // this.props.selectedValue);
    };

    render() {
        if(!this.state.open)
            return false;

        const {showopen, showclose} = this.state
        return(  
            <Dialog
                open={this.state.open}
                // onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth={true} >
                <DialogTitle id="alert-dialog-title">{this.props.title ? this.props.title : 'Confirmation'}</DialogTitle>
                    <DialogContent id="dialogCon" >
                        {this.props.content ? this.props.content : 'Are you sure you wish to Continue?'}<p>&nbsp;</p>
                        <strong>{this.props.conftext?this.props.conftext:''}</strong>
                    </DialogContent>
                <DialogActions>
                {showclose && <Button onClick={() => {this.handleClick(false)}} color="primary">
                    {this.props.cancelPrompt??'Cancel'}
                </Button> }
                {showopen && <Button onClick={() => {this.handleClick(true)}} color="primary" autoFocus>
                    {this.props.okPrompt??'Ok'}
                </Button> }
                </DialogActions>
            </Dialog>
        );
    }
}